export default __webpack_public_path__ + "static/gfx_btn_freeEst@2x-0eabfef13c818fe4ea0d2e8a8ab84dd2.png";